export default __webpack_public_path__ + "static/media/abm.683d767c.svg";